import Cookie from 'js-cookie' 
export default ({ app }) => {
  app.router.afterEach((to, from, next) => {
    let token = Cookie.get("token")
    if(to.path == "/login" || !token) {

    } else {
      if(!app.store.state.app.userInfo.userId) {
        app.store.dispatch("app/getUserInfo").then(res=> {})
      }
    }
  })
}